"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: " 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.93,8.84l3.59,3.61L12.35,9.6,8.75,6A4.55,4.55,0,0,0,7.67,1.33a4.4,4.4,0,0,0-4.86-1,.49.49,0,0,0-.29.35.5.5,0,0,0,.11.44l1.74,2V4.46H3.07L1.15,2.67a.48.48,0,0,0-.44-.12.5.5,0,0,0-.36.29,4.49,4.49,0,0,0,5.58,6Z",
    fill: "#014965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.89,15.19l-3.42-3.45-2.83,2.84L15.07,18a4.53,4.53,0,0,0,1.08,4.65,4.47,4.47,0,0,0,4.93,1,.49.49,0,0,0,.29-.36.47.47,0,0,0-.13-.45l-1.89-2v-1.3h1.31l2,1.86a.49.49,0,0,0,.8-.17,4.51,4.51,0,0,0-5.57-6Z",
    fill: "#014965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.85,1.66,22.36.15a.5.5,0,0,0-.64-.06L18.18,2.56a.51.51,0,0,0-.21.37.52.52,0,0,0,.14.4l.94.94-10,10L7.33,12.53a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l.71.71L1.12,20.2a2,2,0,0,0,0,2.85,2,2,0,0,0,2.82,0l6.21-6.26.71.71a.48.48,0,0,0,.7,0,.5.5,0,0,0,0-.71L9.8,15l10-10,.83.83a.51.51,0,0,0,.35.15h0a.53.53,0,0,0,.37-.2L23.9,2.31A.49.49,0,0,0,23.85,1.66Z",
    fill: "#014965"
  }));
};

exports["default"] = _default;